<template>
  <div :class="alternate ? 'primary lighten-2 pa-2' : 'primary lighten-1 pa-2'">
    <v-layout row wrap>
      <v-flex xs12 sm4 :style="{ margin: 'auto' }">
        <h3>{{ question }}</h3>
      </v-flex>
      <v-flex xs12 sm4>
        <v-btn
          :style="{ width: '90%' }"
          color="success"
          :flat="computeSelection(!data.yes)"
          @click="
          data.yes = true;
          data.no = false;
        "
        >Yes</v-btn>
      </v-flex>
      <v-flex xs12 sm4>
        <v-btn
          :style="{ width: '90%' }"
          color="error"
          :flat="computeSelection(!data.no)"
          @click="
          data.yes = false;
          data.no = true;
        "
        >No</v-btn>
      </v-flex>
    </v-layout>
    <v-layout row wrap v-if="data.no">
      <v-flex xs0 sm4 :style="{ margin: 'auto'}"></v-flex>
      <v-flex xs12 sm8>
        <v-text-field
          :style="{ margin: 'auto' }"
          v-model="data.comments"
          label="Reason"
          box
          color="error"
        />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: "YesOrNo",
  props: {
    question: String,
    alternate: Boolean,
    fillAnswer: Object,
    index: Number
  },
  data() {
    return {
      data: { yes: false, no: false, comments: "" }
    };
  },
  watch: {
    data: {
      handler(val) {
        let data = {
          question: this.question,
          val
        };
        if (data.val.yes) data.val.comments = "";
        if (this.index != null) {
          data["index"] = this.index;
        }
        this.$emit("data", data);
      },
      deep: true
    },
    fillAnswer: {
      handler(val) {
        if (val) this.data = val;
        else
          this.data = {
            yes: false,
            no: false,
            comments: ""
          };
      },
      deep: true
    }
  },
  methods: {
    computeSelection(selection) {
      if (selection) return true;
      else return false;
    }
  },
  mounted() {
    if (this.fillAnswer) {
      this.data = this.fillAnswer;
    } else {
      this.data = {
        yes: false,
        no: false,
        comments: ""
      };
    }
  },
  destroyed() {
    this.data = {
      yes: false,
      no: false,
      comments: ""
    };
  }
};
</script>

<style></style>
